'use es6';

import { createSelector } from 'reselect';
import { getCurrentThreadHistoryEntry } from './getCurrentThreadHistoryEntry';
export const getChannelInstanceIdFromCurrentThreadHistory = createSelector(getCurrentThreadHistoryEntry, historyEntry => {
  return historyEntry.data.messages.results.toList().filter(msg => !(msg.channelInstanceId === null || msg.channelInstanceId === undefined)).sort((msg1, msg2) => msg1.timeStamp - msg2.timeStamp).last().channelInstanceId;
});